import { colors } from '@/constants/colors';
import React from 'react';
import styled from 'styled-components';

interface Props {
   title: string;
   type: string;
   onClick: () => void;
}

const PageActionItem = ({ title, type, onClick }: Props) => {
   const handleOnClick = () => {
      onClick();
   };
   switch (type) {
      case 'normal':
         return (
            <div onClick={handleOnClick}>
               <BtnNormal>{title}</BtnNormal>
            </div>
         );
      case 'button':
         return (
            <div onClick={handleOnClick}>
               <BtnButton>{title}</BtnButton>
            </div>
         );
      default:
         return (
            <div onClick={handleOnClick}>
               <BtnButton>{title}</BtnButton>
            </div>
         );
   }
};

const BtnNormal = styled.div`
   /* border: 1px solid ${colors.GRAY12};
   border-radius: 5px; */
   padding: 5px 10px;
   /* background: ${colors.GRAY14}; */
   color: ${colors.PRIMARY};
   cursor: pointer;
   font-weight: 600;
   font-size: 14px;
   text-transform: capitalize;
`;

const BtnButton = styled.div`
   border: 1px solid ${colors.GRAY12};
   border-radius: 5px;
   padding: 5px 10px;
   background: ${colors.PRIMARY};
   color: white;
   cursor: pointer;
   font-weight: 600;
   font-size: 14px;
   text-transform: capitalize;
`;

export default PageActionItem;
